/**
 * useNotifications — Hook to access the notification context.
 *
 * Provides access to notifications, unread count, and mark-all-read action
 * from the NotificationProvider context.
 */

import { useContext } from 'react';
import {
  NotificationContext,
  type NotificationContextValue,
} from '../providers/NotificationProvider';

/**
 * Access the notification context.
 * Must be used within a NotificationProvider.
 *
 * @throws Error if used outside NotificationProvider
 */
export function useNotifications(): NotificationContextValue {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error(
      'useNotifications must be used within a NotificationProvider'
    );
  }
  return ctx;
}
